import React from "react";
import PropTypes from "prop-types";
import ModalButtons from "../layouts/modal-buttons";
var Menu = require("./menu").Menu;

class ContextModal extends React.Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
  }

  render() {
    const {
      title,
      content,
      buttons,
      delegateButtons,
      modalCloseCallback
    } = this.props;
    const hasButtons = buttons.length || delegateButtons;
    return (
      <Menu {...this.props}>
        <div className="modal">
          <div ref={this.modalRef} className="modal-box">
            <h2 className="modal-title" tabIndex={-1}>
              {title}
            </h2>

            <div
              className={`modal-content ${hasButtons ? "with-buttons" : ""}`}
            >
              {content}
            </div>

            <ModalButtons
              buttons={buttons}
              modalCloseCallback={modalCloseCallback}
            />
          </div>
        </div>
      </Menu>
    );
  }
}

ContextModal.propTypes = {
  content: PropTypes.node.isRequired,
  modalCloseCallback: PropTypes.func,
  title: PropTypes.string,
  delegateButtons: PropTypes.bool,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      click: PropTypes.func.isRequired,
      label: PropTypes.string,
      color: PropTypes.string
    })
  )
};

ContextModal.defaultProps = {
  title: "",
  buttons: [],
  delegateButtons: false
};

export { ContextModal };
